/**
 * subjects 注册表(`["@token: 外观描述"]`)的解析 —— 与 ai `parse_subject_registry` 同口径。
 * 它是跨镜一致性的唯一机制(文本锁):编译层把每镜的 @token 展开成注册表里同一段描述。
 * token 名是各镜 panelSubjectRefs 的引用键,**只读**;UI 只允许改描述。
 */

/** `"@token: 描述"` → { token, desc };容错全角冒号/缺 @。写回时按 `@token: desc` 重拼。 */
export function parseSubjectEntry(entry: string): { token: string; desc: string } {
  const m = /^\s*@?([^::]+)[::]\s*(.*)$/.exec(entry ?? "");
  if (!m) return { token: (entry ?? "").trim().replace(/^@/, ""), desc: "" };
  return { token: m[1].trim(), desc: m[2].trim() };
}
